import styled from '@happymoneyinc/styled-components';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTimelineContext } from './TimelineContext.js';
import { jsx } from 'react/jsx-runtime';

const TimelineContent = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const {
    horizontal
  } = useTimelineContext();
  return /*#__PURE__*/jsx(Container, {
    className: clsx({
      horizontal
    }, className),
    ...rest,
    children: children
  });
};
const Container = styled.div`
  &.horizontal {
    padding-top: 0.75rem;
    padding-right: 2rem;
  }
`;
TimelineContent.defaultProps = {
  className: '',
  children: null
};
TimelineContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { TimelineContent };
//# sourceMappingURL=TimelineContent.js.map
